import removePreCheckout from "../../../../graphQl/mutations/removePreCheckout";

export const removePreCheckoutPage = async ({dispatch, rootGetters}, payload) => {
    let removeStatusData;

    const organizationId = rootGetters['app/getSelectedOrganization'].id;
    const variables = {
        organizationId,
        ...payload,
    };

    try {
        removeStatusData = await dispatch('app/request', {
            type: 'mutation',
            gql: removePreCheckout,
            variables,
        }, {root: true});
    } catch (error) {
        return error;
    }

    if (removeStatusData.message) {
        throw removeStatusData.message;
    }

    if (removeStatusData.errors) {
        throw removeStatusData.errors;
    }

    const {
        data: {deletePreCheckout},
    } = removeStatusData;

    return deletePreCheckout;
};